<template>
  <div class="page-header-com" :style="{ paddingTop: !headers ? '24px' : '0' }">
    <div class="header-box" v-if="headers">
      <div class="header-left">
        <div class="back-icon" @click="$router.go(-1)" v-if="backBtn">
          <return theme="outline" size="24" fill="#888888" strokeLinejoin="bevel" strokeLinecap="square" />
        </div>
        <slot name="headerLeft">
          <div class="title">
            {{ title ? title : $route.meta.title }}
          </div>
        </slot>
      </div>
      <div class="header-right">
        <!-- 头部插槽 -->
        <slot name="headerRight"></slot>
      </div>
    </div>
    <div class="content-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Return } from '@icon-park/vue'
export default {
  components: {
    Return,
  },
  name: 'PageHeaderCom',
  props: {
    headers: {
      default: () => true,
    },
    // 标题
    title: {
      default: '',
    },
    backBtn: {
      default: () => {
        return false
      },
    },
  },
}
</script>
<style lang="less" scoped>
.page-header-com {
  // padding: 0 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  .header-box {
    height: 64px;
    display: flex;
    justify-content: space-between;
    background: #f0f0f0;
    align-items: center;
  }
  .header-left {
    display: flex;
    align-items: center;
  }
  .back-icon {
    margin-right: 15px;
    cursor: pointer;
    margin-top: 3px;
  }
  .title {
    color: #000000d9;
    font-size: 20px;
    font-style: normal;
    font-weight: bold;
  }
  .header-right {
    display: flex;
    align-items: center;
    // flex: 1;
  }
  .content-box {
    flex: 1;
    align-self: auto;
    min-width: 0;
    min-height: 0;
    // overflow: auto;
    border-radius: 16px;
    // background: var(--bg-card-white, #fff);
    box-shadow: 0 4px 16px 0 #165dff0d;
    .ant-card {
      min-height: 100%;
    }
  }
}
</style>
